import { createFileRoute, redirect } from '@tanstack/react-router';

/** Moved into the Campaigns hub as the "Do-not-contact" tab. Redirect keeps old
 *  links and bookmarks working. */
export const Route = createFileRoute('/vendor/campaigns/suppression')({
  beforeLoad: () => {
    throw redirect({ to: '/vendor/campaigns', search: { tab: 'suppression' } });
  },
});
